module.exports = __webpack_public_path__ + "static/media/event-services-img14.75059483.jpg";